export default {
    signature: null,
    cosigner: null,
    content: null,
    term: null,
    teacher: null,
    institution: null,
    loading: false,
    error: null,
}
